import { ITask } from '../../../data_models/task'
import { EProjectStatus, IProject } from '../../../data_models/project'

import { IFreelancer } from '../../../data_models/freelancer'

import { IEmployer } from '../../../data_models/employer';
import { HiMiniCheckCircle } from 'react-icons/hi2';
import { useEffect, useState } from 'react';
import { set } from 'lodash';
import { EProjectDetailsNav } from '../../../hooks/useRouting';
import { useSearchParams } from 'react-router-dom';


export const ProjectDetailsNavigation: React.FC<{
    project: IProject,
    tasks: ITask[],
    projectManager: IFreelancer | null,
    team: IFreelancer[],
    employer: IEmployer | null,
    isPm: boolean,
    isEmployer: boolean,
    isFreelancer: boolean,
    isOutsideFreelancer: boolean,
    isOutsideEmployer: boolean,

    setProject: (project: IProject) => void,
    setTasks: (tasks: ITask[]) => void,

    navigation: any[],
    setNavigation: (navigation: any[]) => void,
}> = ({ project, tasks, team, navigation, setNavigation }) => {

    const [searchParams] = useSearchParams();

    const onNavigate = (nav: EProjectDetailsNav) => {
        let newNav: any;
        for(let i = 0; i < navigation.length; i++){
            const item = navigation[i];
            if(item.nav?.toLowerCase() === nav?.toLowerCase()){
                newNav = item;
                break;
            } 
        }

        const newNavigation = navigation.map(item => ({
            ...item,
            current: item.nav.toLowerCase() === (newNav.nav).toLowerCase()
        }));


       
        setNavigation(newNavigation);
    }

    // Initialize navigation based on URL parameter
    useEffect(() => {
        const navParam = searchParams.get('nav')?.toLowerCase() as EProjectDetailsNav;
        onNavigate(navParam || EProjectDetailsNav.OVERVIEW);
    }, []);

    const [currentSteps, setCurrentSteps] = useState<any[]>([
        { name: 'Creating Project', status: 'complete' },
        { name: 'Shaping The Idea', status: 'current' },
        { name: 'Roadmap Created', status: 'upcoming' },
        { name: 'Verified', status: 'upcoming' },
        { name: 'Make it happen', status: 'upcoming' },
        { name: 'Completed', status: 'upcoming' },
    ])

    useEffect(() => {
        if (!project || !tasks) return

        // DEFINE THE STEPS

        let createProject = 'complete';
        let shapeTheIdea = 'complete';
        let roadmapCreated = 'upcoming';
        let verified = 'upcoming';
        let makeItHappen = 'upcoming';
        let completed = 'upcoming';

        // shape the idea
        if (project.status === EProjectStatus.DRAFT && tasks.length === 0) {
            shapeTheIdea = 'current';
        }
        // roadmap created
        if (tasks.length > 0 && (project.status || 0) < EProjectStatus.IN_PROGRESS && !project._roadmapVerifiedAt) {
            roadmapCreated = 'current';
        } else if (project.status && project.status >= EProjectStatus.IN_PROGRESS) {
            roadmapCreated = 'complete';
        }

        // verified
        if (project._waitingForRoadmapVerification && !project._roadmapVerifiedAt) {
            verified = 'current';
        } else if (project.status && project.status >= EProjectStatus.IN_PROGRESS && !project._roadmapVerifiedAt) {
            verified = 'skipped';
        } else if (project._roadmapVerifiedAt) {
            verified = 'complete';
            roadmapCreated = 'complete';
        }
        // make it happen
        if (project.status === EProjectStatus.IN_PROGRESS) {
            makeItHappen = 'current';
        }
        // completed
        if (project.status === EProjectStatus.COMPLETED) {
            completed = 'complete';
            makeItHappen = 'complete';
        }

        setCurrentSteps([
            { name: 'Creating Project', status: createProject },
            { name: 'Shaping The Idea', status: shapeTheIdea },
            { name: 'Roadmap Created', status: roadmapCreated },
            { name: 'Verified By Expert', status: verified },
            { name: 'Make it happen', status: makeItHappen },
            { name: 'Completed', status: completed },
        ])

        // DEFINE THE NAVIGATION
        const newNavigation = [];
        for (const nav of navigation) {
            if (nav.name === 'Roadmap') {
                newNavigation.push({ ...nav, count: tasks.length });
            } else if (nav.name === 'Team') {
                newNavigation.push({ ...nav, count: team.length });
            } else {
                newNavigation.push({ ...nav, count: null });
            }
        }
        setNavigation(newNavigation);
    }, [project, tasks])

    return (
        <nav aria-label="Sidebar" className="flex flex-1 flex-col">
            {/* Stepper */}
            <nav aria-label="Progress" className="flex justify-center">
                <ol role="list" className="-ml-5 space-y-6">
                    {currentSteps.map((step) => (
                        <div key={step.name}>
                            {step.status === 'complete' ? (
                                <div className="group">
                                    <span className="flex items-start">
                                        <span className="relative flex size-5 shrink-0 items-center justify-center">
                                            <HiMiniCheckCircle
                                                aria-hidden="true"
                                                className="size-full text-primary-600 group-hover:text-primary-800"
                                            />
                                        </span>
                                        <span className="ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900">
                                            {step.name}
                                        </span>
                                    </span>
                                </div>
                            ) : step.status === 'current' ? (
                                <div aria-current="step" className="flex items-start">
                                    <span aria-hidden="true" className="relative flex size-5 shrink-0 items-center justify-center">
                                        <span className="absolute size-4 rounded-full bg-primary-200" />
                                        <span className="relative block size-2 rounded-full bg-primary-600" />
                                    </span>
                                    <span className="ml-3 text-sm font-medium text-primary-600">{step.name}</span>
                                </div>
                            ) : step.status === 'skipped' ? (
                                <div className="flex items-start">
                                    <div aria-hidden="true" className="relative flex size-5 shrink-0 items-center justify-center">
                                        <div className="size-2 rounded-full bg-amber-500 group-hover:bg-amber-400" />
                                    </div>
                                    <p className="ml-3 text-sm font-medium text-amber-500 group-hover:text-amber-900">{step.name} (Skipped)</p>
                                </div>
                            )
                                : (
                                    <div className="flex items-start">
                                        <div aria-hidden="true" className="relative flex size-5 shrink-0 items-center justify-center">
                                            <div className="size-2 rounded-full bg-gray-300 group-hover:bg-gray-400" />
                                        </div>
                                        <p className="ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900">{step.name}</p>
                                    </div>
                                )}
                        </div>
                    ))}
                </ol>
            </nav>

            <hr className="my-4" />

            {/* Navigation */}
            <ul role="list" className="-mx-2 space-y-1">
                {navigation.map((item) => (
                    <div key={item.name} onClick={() => onNavigate(item.nav)}>
                        <span
                            className={`group flex gap-x-3 rounded-md p-2 pl-3 text-sm/6 font-semibold cursor-pointer transition-all duration-300
                                ${item.current
                                    ? 'bg-gray-50 text-primary-600'
                                    : 'text-gray-700 hover:bg-gray-50 hover:text-primary-600'}`}
                        >
                            {item.name}
                            {item.count !== null && item.count !== undefined ? (
                                <span
                                    aria-hidden="true"
                                    className="ml-auto w-9 min-w-max rounded-full bg-white px-2.5 py-0.5 text-center text-xs/5 font-medium whitespace-nowrap text-gray-600 ring-1 ring-gray-200 ring-inset"
                                >
                                    {item.count}
                                </span>
                            ) : null}
                        </span>
                    </div>
                ))}
            </ul>
        </nav>
    )
}